export const mockData = {
  company: {
    name: 'SB Consulting',
    tagline: 'Cabinet de Conseil et Études Thermiques',
    address: '72 rue Aristide Briand',
    postalCode: '92300',
    city: 'Levallois-Perret',
    phone: '01 XX XX XX XX',
    email: 'contact@sb-consulting.archi'
  },
  services: [
    {
      id: 1,
      title: 'Études Thermiques Réglementaires',
      description: 'Conformité RT2012 et RE2020 pour vos projets de construction neuve. Optimisation thermique et respect des normes en vigueur.',
      icon: 'FileCheck',
      features: ['RT2012', 'RE2020', 'Attestations', 'Simulations thermiques']
    },
    {
      id: 2,
      title: 'Diagnostic de Performance Énergétique',
      description: 'DPE complets pour la vente ou la location de vos biens immobiliers. Analyse détaillée et recommandations personnalisées.',
      icon: 'Gauge',
      features: ['DPE vente', 'DPE location', 'Audit réglementaire', 'Classement énergétique']
    },
    {
      id: 3,
      title: 'Audits Énergétiques',
      description: 'Analyse approfondie de votre consommation énergétique avec plan d\'action détaillé pour réduire vos coûts.',
      icon: 'Search',
      features: ['Audit complet', 'Analyse thermographique', 'Plan d\'économies', 'Bilan carbone']
    },
    {
      id: 4,
      title: 'Conseil en Rénovation Énergétique',
      description: 'Accompagnement personnalisé pour vos projets de rénovation. Optimisation des aides financières et suivi de chantier.',
      icon: 'Lightbulb',
      features: ['Étude de faisabilité', 'Dossier MaPrimeRénov', 'Suivi travaux', 'Optimisation budget']
    }
  ],
  projects: [
    {
      id: 1,
      title: 'Résidence Les Jardins',
      location: 'Levallois-Perret',
      type: 'Neuf - 45 logements',
      description: 'Étude thermique complète RE2020 avec optimisation des performances énergétiques',
      year: '2024',
      image: 'https://images.unsplash.com/photo-1565363887715-8884629e09ee'
    },
    {
      id: 2,
      title: 'Immeuble Haussmannien',
      location: 'Paris 17ème',
      type: 'Rénovation',
      description: 'Audit énergétique et accompagnement rénovation complète avec isolation thermique',
      year: '2023',
      image: 'https://images.unsplash.com/photo-1670407203479-a4e2d7ffc616'
    },
    {
      id: 3,
      title: 'Centre Commercial Espace Ouest',
      location: 'Neuilly-sur-Seine',
      type: 'Tertiaire',
      description: 'DPE tertiaire et plan d\'amélioration énergétique sur 5 ans',
      year: '2023',
      image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab'
    },
    {
      id: 4,
      title: 'Immeuble de Bureaux',
      location: 'Asnières-sur-Seine',
      type: 'Tertiaire - Bureau',
      description: 'Étude thermique et certification environnementale pour complexe de bureaux moderne',
      year: '2024',
      image: 'https://images.unsplash.com/photo-1574958269340-fa927503f3dd?q=85'
    }
  ],
  about: {
    title: 'Votre Expert en Performance Énergétique',
    description: 'SB Consulting est un cabinet spécialisé dans les études thermiques et le conseil en efficacité énergétique. Fort d\'une expertise reconnue, nous accompagnons particuliers, professionnels et promoteurs dans leurs projets de construction et de rénovation.',
    values: [
      {
        title: 'Expertise',
        description: 'Une équipe d\'ingénieurs qualifiés et certifiés',
        icon: 'Award'
      },
      {
        title: 'Réactivité',
        description: 'Des délais respectés et un suivi personnalisé',
        icon: 'Zap'
      },
      {
        title: 'Innovation',
        description: 'Les dernières technologies et méthodes d\'analyse',
        icon: 'Sparkles'
      }
    ],
    stats: [
      { number: '500+', label: 'Projets réalisés' },
      { number: '15 ans', label: 'D\'expérience' },
      { number: '98%', label: 'Clients satisfaits' }
    ]
  },
  testimonials: [
    {
      id: 1,
      name: 'Marie Laurent',
      role: 'Architecte',
      content: 'Collaboration parfaite sur plusieurs projets. SB Consulting est réactif, précis et force de proposition.',
      rating: 5
    },
    {
      id: 2,
      name: 'Pierre Durand',
      role: 'Promoteur immobilier',
      content: 'Excellent accompagnement sur nos opérations RE2020. Une vraie expertise qui fait la différence.',
      rating: 5
    }
  ]
};
